import script from "./SettingsEntities.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsEntities.vue?vue&type=script&setup=true&lang=js"

import "./SettingsEntities.vue?vue&type=style&index=0&id=28fbfccd&lang=css"

const __exports__ = script;

export default __exports__